module.exports = __webpack_public_path__ + "static/mentoring-project-rebound-students-497cfe3cb39bf475e1a8ef4808e33fe1.jpg";